// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    sapiGetCopyTradingFuturesUserStatus (params?: {}): Promise<Dict>;
    sapiGetCopyTradingFuturesLeadSymbol (params?: {}): Promise<Dict>;
    sapiGetSystemStatus (params?: {}): Promise<Dict>;
    sapiGetAccountSnapshot (params?: {}): Promise<Dict>;
    sapiGetAccountInfo (params?: {}): Promise<Dict>;
    sapiGetMarginAsset (params?: {}): Promise<Dict>;
    sapiGetMarginPair (params?: {}): Promise<Dict>;
    sapiGetMarginAllAssets (params?: {}): Promise<List>;
    sapiGetMarginAllPairs (params?: {}): Promise<List>;
    sapiGetMarginPriceIndex (params?: {}): Promise<Dict>;
    sapiGetSpotDelistSchedule (params?: {}): Promise<List>;
    sapiGetAssetAssetDividend (params?: {}): Promise<Dict>;
    sapiGetAssetDribblet (params?: {}): Promise<Dict>;
    sapiGetAssetTransfer (params?: {}): Promise<Dict>;
    sapiGetAssetAssetDetail (params?: {}): Promise<Dict>;
    sapiGetAssetTradeFee (params?: {}): Promise<Dict>;
    sapiGetAssetLedgerTransferCloudMiningQueryByPage (params?: {}): Promise<Dict>;
    sapiGetAssetConvertTransferQueryByPage (params?: {}): Promise<Dict>;
    sapiGetAssetWalletBalance (params?: {}): Promise<List>;
    sapiGetAssetCustodyTransferHistory (params?: {}): Promise<Dict>;
    sapiGetMarginBorrowRepay (params?: {}): Promise<Dict>;
    sapiGetMarginLoan (params?: {}): Promise<Dict>;
    sapiGetMarginRepay (params?: {}): Promise<Dict>;
    sapiGetMarginAccount (params?: {}): Promise<Dict>;
    sapiGetMarginTransfer (params?: {}): Promise<Dict>;
    sapiGetMarginInterestHistory (params?: {}): Promise<Dict>;
    sapiGetMarginForceLiquidationRec (params?: {}): Promise<Dict>;
    sapiGetMarginOrder (params?: {}): Promise<Dict>;
    sapiGetMarginOpenOrders (params?: {}): Promise<List>;
    sapiGetMarginAllOrders (params?: {}): Promise<List>;
    sapiGetMarginMyTrades (params?: {}): Promise<List>;
    sapiGetMarginMaxBorrowable (params?: {}): Promise<Dict>;
    sapiGetMarginMaxTransferable (params?: {}): Promise<Dict>;
    sapiGetMarginTradeCoeff (params?: {}): Promise<Dict>;
    sapiGetMarginIsolatedTransfer (params?: {}): Promise<Dict>;
    sapiGetMarginIsolatedAccount (params?: {}): Promise<Dict>;
    sapiGetMarginIsolatedPair (params?: {}): Promise<Dict>;
    sapiGetMarginIsolatedAllPairs (params?: {}): Promise<List>;
    sapiGetMarginIsolatedAccountLimit (params?: {}): Promise<Dict>;
    sapiGetMarginInterestRateHistory (params?: {}): Promise<List>;
    sapiGetMarginOrderList (params?: {}): Promise<Dict>;
    sapiGetMarginAllOrderList (params?: {}): Promise<List>;
    sapiGetMarginOpenOrderList (params?: {}): Promise<List>;
    sapiGetMarginCrossMarginData (params?: {}): Promise<List>;
    sapiGetMarginIsolatedMarginData (params?: {}): Promise<List>;
    sapiGetMarginIsolatedMarginTier (params?: {}): Promise<List>;
    sapiGetMarginRateLimitOrder (params?: {}): Promise<List>;
    sapiGetMarginDribblet (params?: {}): Promise<Dict>;
    sapiGetMarginDust (params?: {}): Promise<Dict>;
    sapiGetMarginCrossMarginCollateralRatio (params?: {}): Promise<List>;
    sapiGetMarginExchangeSmallLiability (params?: {}): Promise<List>;
    sapiGetMarginExchangeSmallLiabilityHistory (params?: {}): Promise<Dict>;
    sapiGetMarginNextHourlyInterestRate (params?: {}): Promise<List>;
    sapiGetMarginCapitalFlow (params?: {}): Promise<List>;
    sapiGetMarginDelistSchedule (params?: {}): Promise<List>;
    sapiGetMarginAvailableInventory (params?: {}): Promise<Dict>;
    sapiGetMarginLeverageBracket (params?: {}): Promise<List>;
    sapiGetLoanVipLoanableData (params?: {}): Promise<Dict>;
    sapiGetLoanVipCollateralData (params?: {}): Promise<Dict>;
    sapiGetLoanVipRequestData (params?: {}): Promise<Dict>;
    sapiGetLoanVipRequestInterestRate (params?: {}): Promise<List>;
    sapiGetLoanIncome (params?: {}): Promise<List>;
    sapiGetLoanOngoingOrders (params?: {}): Promise<Dict>;
    sapiGetLoanLtvAdjustmentHistory (params?: {}): Promise<Dict>;
    sapiGetLoanBorrowHistory (params?: {}): Promise<Dict>;
    sapiGetLoanRepayHistory (params?: {}): Promise<Dict>;
    sapiGetLoanLoanableData (params?: {}): Promise<Dict>;
    sapiGetLoanCollateralData (params?: {}): Promise<Dict>;
    sapiGetLoanRepayCollateralRate (params?: {}): Promise<Dict>;
    sapiGetLoanFlexibleOngoingOrders (params?: {}): Promise<Dict>;
    sapiGetLoanFlexibleBorrowHistory (params?: {}): Promise<Dict>;
    sapiGetLoanFlexibleRepayHistory (params?: {}): Promise<Dict>;
    sapiGetLoanFlexibleLtvAdjustmentHistory (params?: {}): Promise<Dict>;
    sapiGetLoanVipOngoingOrders (params?: {}): Promise<Dict>;
    sapiGetLoanVipRepayHistory (params?: {}): Promise<Dict>;
    sapiGetLoanVipCollateralAccount (params?: {}): Promise<Dict>;
    sapiGetFiatOrders (params?: {}): Promise<Dict>;
    sapiGetFiatPayments (params?: {}): Promise<Dict>;
    sapiGetFuturesTransfer (params?: {}): Promise<Dict>;
    sapiGetFuturesHistDataLink (params?: {}): Promise<Dict>;
    sapiGetRebateTaxQuery (params?: {}): Promise<Dict>;
    sapiGetCapitalConfigGetall (params?: {}): Promise<List>;
    sapiGetCapitalDepositAddress (params?: {}): Promise<Dict>;
    sapiGetCapitalDepositAddressList (params?: {}): Promise<List>;
    sapiGetCapitalDepositHisrec (params?: {}): Promise<List>;
    sapiGetCapitalDepositSubAddress (params?: {}): Promise<Dict>;
    sapiGetCapitalDepositSubHisrec (params?: {}): Promise<List>;
    sapiGetCapitalWithdrawHistory (params?: {}): Promise<List>;
    sapiGetCapitalWithdrawAddressList (params?: {}): Promise<List>;
    sapiGetCapitalContractConvertibleCoins (params?: {}): Promise<Dict>;
    sapiGetConvertTradeFlow (params?: {}): Promise<Dict>;
    sapiGetConvertExchangeInfo (params?: {}): Promise<List>;
    sapiGetConvertAssetInfo (params?: {}): Promise<List>;
    sapiGetConvertOrderStatus (params?: {}): Promise<Dict>;
    sapiGetConvertLimitQueryOpenOrders (params?: {}): Promise<Dict>;
    sapiGetAccountStatus (params?: {}): Promise<Dict>;
    sapiGetAccountApiTradingStatus (params?: {}): Promise<Dict>;
    sapiGetAccountApiRestrictionsIpRestriction (params?: {}): Promise<Dict>;
    sapiGetBnbBurn (params?: {}): Promise<Dict>;
    sapiGetSubAccountFuturesAccount (params?: {}): Promise<Dict>;
    sapiGetSubAccountFuturesAccountSummary (params?: {}): Promise<Dict>;
    sapiGetSubAccountFuturesPositionRisk (params?: {}): Promise<List>;
    sapiGetSubAccountFuturesInternalTransfer (params?: {}): Promise<Dict>;
    sapiGetSubAccountList (params?: {}): Promise<Dict>;
    sapiGetSubAccountMarginAccount (params?: {}): Promise<Dict>;
    sapiGetSubAccountMarginAccountSummary (params?: {}): Promise<Dict>;
    sapiGetSubAccountSpotSummary (params?: {}): Promise<Dict>;
    sapiGetSubAccountStatus (params?: {}): Promise<List>;
    sapiGetSubAccountSubTransferHistory (params?: {}): Promise<List>;
    sapiGetSubAccountTransferSubUserHistory (params?: {}): Promise<List>;
    sapiGetSubAccountUniversalTransfer (params?: {}): Promise<Dict>;
    sapiGetSubAccountApiRestrictionsIpRestrictionThirdPartyList (params?: {}): Promise<Dict>;
    sapiGetSubAccountTransactionStatistics (params?: {}): Promise<Dict>;
    sapiGetSubAccountSubAccountApiIpRestriction (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountAsset (params?: {}): Promise<List>;
    sapiGetManagedSubaccountAccountSnapshot (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountQueryTransLogForInvestor (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountQueryTransLogForTradeParent (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountFetchFutureAsset (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountMarginAsset (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountInfo (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountDepositAddress (params?: {}): Promise<Dict>;
    sapiGetManagedSubaccountQueryTransLog (params?: {}): Promise<Dict>;
    sapiGetLendingDailyProductList (params?: {}): Promise<List>;
    sapiGetLendingDailyUserLeftQuota (params?: {}): Promise<Dict>;
    sapiGetLendingDailyUserRedemptionQuota (params?: {}): Promise<Dict>;
    sapiGetLendingDailyTokenPosition (params?: {}): Promise<List>;
    sapiGetLendingUnionAccount (params?: {}): Promise<Dict>;
    sapiGetLendingUnionPurchaseRecord (params?: {}): Promise<List>;
    sapiGetLendingUnionRedemptionRecord (params?: {}): Promise<Dict>;
    sapiGetLendingUnionInterestHistory (params?: {}): Promise<List>;
    sapiGetLendingProjectList (params?: {}): Promise<List>;
    sapiGetLendingProjectPositionList (params?: {}): Promise<List>;
    sapiGetEthStakingEthHistoryStakingHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingEthHistoryRedemptionHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingEthHistoryRewardsHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingEthQuota (params?: {}): Promise<Dict>;
    sapiGetEthStakingEthHistoryRateHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingAccount (params?: {}): Promise<Dict>;
    sapiGetEthStakingWbethHistoryWrapHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingWbethHistoryUnwrapHistory (params?: {}): Promise<Dict>;
    sapiGetEthStakingEthHistoryWbethRewardsHistory (params?: {}): Promise<Dict>;
    sapiGetSolStakingSolHistoryStakingHistory (params?: {}): Promise<Dict>;
    sapiGetSolStakingSolHistoryRedemptionHistory (params?: {}): Promise<Dict>;
    sapiGetSolStakingSolHistoryBnsolRewardsHistory (params?: {}): Promise<Dict>;
    sapiGetSolStakingSolHistoryRateHistory (params?: {}): Promise<Dict>;
    sapiGetSolStakingAccount (params?: {}): Promise<Dict>;
    sapiGetSolStakingSolQuota (params?: {}): Promise<Dict>;
    sapiGetMiningPubAlgoList (params?: {}): Promise<Dict>;
    sapiGetMiningPubCoinList (params?: {}): Promise<Dict>;
    sapiGetMiningWorkerDetail (params?: {}): Promise<Dict>;
    sapiGetMiningWorkerList (params?: {}): Promise<Dict>;
    sapiGetMiningPaymentList (params?: {}): Promise<Dict>;
    sapiGetMiningStatisticsUserStatus (params?: {}): Promise<Dict>;
    sapiGetMiningStatisticsUserList (params?: {}): Promise<Dict>;
    sapiGetMiningPaymentUid (params?: {}): Promise<Dict>;
    sapiGetBswapPools (params?: {}): Promise<List>;
    sapiGetBswapLiquidity (params?: {}): Promise<List>;
    sapiGetBswapLiquidityOps (params?: {}): Promise<List>;
    sapiGetBswapQuote (params?: {}): Promise<Dict>;
    sapiGetBswapSwap (params?: {}): Promise<List>;
    sapiGetBswapPoolConfigure (params?: {}): Promise<List>;
    sapiGetBswapAddLiquidityPreview (params?: {}): Promise<Dict>;
    sapiGetBswapRemoveLiquidityPreview (params?: {}): Promise<Dict>;
    sapiGetBswapUnclaimedRewards (params?: {}): Promise<Dict>;
    sapiGetBswapClaimedHistory (params?: {}): Promise<List>;
    sapiGetBlvtTokenInfo (params?: {}): Promise<List>;
    sapiGetBlvtSubscribeRecord (params?: {}): Promise<List>;
    sapiGetBlvtRedeemRecord (params?: {}): Promise<List>;
    sapiGetBlvtUserLimit (params?: {}): Promise<List>;
    sapiGetApiReferralIfNewUser (params?: {}): Promise<Dict>;
    sapiGetApiReferralCustomization (params?: {}): Promise<List>;
    sapiGetApiReferralUserCustomization (params?: {}): Promise<Dict>;
    sapiGetApiReferralRebateRecentRecord (params?: {}): Promise<List>;
    sapiGetApiReferralRebateHistoricalRecord (params?: {}): Promise<List>;
    sapiGetApiReferralKickbackRecentRecord (params?: {}): Promise<List>;
    sapiGetApiReferralKickbackHistoricalRecord (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountApi (params?: {}): Promise<List>;
    sapiGetBrokerSubAccount (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountApiCommissionFutures (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountApiCommissionCoinFutures (params?: {}): Promise<List>;
    sapiGetBrokerInfo (params?: {}): Promise<Dict>;
    sapiGetBrokerTransfer (params?: {}): Promise<List>;
    sapiGetBrokerTransferFutures (params?: {}): Promise<Dict>;
    sapiGetBrokerRebateRecentRecord (params?: {}): Promise<List>;
    sapiGetBrokerRebateHistoricalRecord (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountBnbBurnStatus (params?: {}): Promise<Dict>;
    sapiGetBrokerSubAccountDepositHist (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountSpotSummary (params?: {}): Promise<Dict>;
    sapiGetBrokerSubAccountMarginSummary (params?: {}): Promise<Dict>;
    sapiGetBrokerSubAccountFuturesSummary (params?: {}): Promise<Dict>;
    sapiGetBrokerRebateFuturesRecentRecord (params?: {}): Promise<List>;
    sapiGetBrokerSubAccountApiIpRestriction (params?: {}): Promise<Dict>;
    sapiGetBrokerUniversalTransfer (params?: {}): Promise<List>;
    sapiGetAccountApiRestrictions (params?: {}): Promise<Dict>;
    sapiGetC2cOrderMatchListUserOrderHistory (params?: {}): Promise<Dict>;
    sapiGetNftHistoryTransactions (params?: {}): Promise<Dict>;
    sapiGetNftHistoryDeposit (params?: {}): Promise<Dict>;
    sapiGetNftHistoryWithdraw (params?: {}): Promise<Dict>;
    sapiGetNftUserGetAsset (params?: {}): Promise<Dict>;
    sapiGetPayTransactions (params?: {}): Promise<Dict>;
    sapiGetGiftcardVerify (params?: {}): Promise<Dict>;
    sapiGetGiftcardCryptographyRsaPublicKey (params?: {}): Promise<Dict>;
    sapiGetGiftcardBuyCodeTokenLimit (params?: {}): Promise<Dict>;
    sapiGetAlgoSpotOpenOrders (params?: {}): Promise<Dict>;
    sapiGetAlgoSpotHistoricalOrders (params?: {}): Promise<Dict>;
    sapiGetAlgoSpotSubOrders (params?: {}): Promise<Dict>;
    sapiGetAlgoFuturesOpenOrders (params?: {}): Promise<Dict>;
    sapiGetAlgoFuturesHistoricalOrders (params?: {}): Promise<Dict>;
    sapiGetAlgoFuturesSubOrders (params?: {}): Promise<Dict>;
    sapiGetPortfolioAccount (params?: {}): Promise<Dict>;
    sapiGetPortfolioCollateralRate (params?: {}): Promise<List>;
    sapiGetPortfolioPmLoan (params?: {}): Promise<Dict>;
    sapiGetPortfolioInterestHistory (params?: {}): Promise<List>;
    sapiGetPortfolioAssetIndexPrice (params?: {}): Promise<List>;
    sapiGetPortfolioRepayFuturesSwitch (params?: {}): Promise<Dict>;
    sapiGetPortfolioMarginAssetLeverage (params?: {}): Promise<List>;
    sapiGetPortfolioBalance (params?: {}): Promise<List>;
    sapiGetPortfolioNegativeBalanceExchangeRecord (params?: {}): Promise<List>;
    sapiGetPortfolioPmloanHistory (params?: {}): Promise<Dict>;
    sapiGetPortfolioEarnAssetBalance (params?: {}): Promise<Dict>;
    sapiGetPortfolioDeltaMode (params?: {}): Promise<Dict>;
    sapiGetStakingProductList (params?: {}): Promise<List>;
    sapiGetStakingPosition (params?: {}): Promise<List>;
    sapiGetStakingStakingRecord (params?: {}): Promise<List>;
    sapiGetStakingPersonalLeftQuota (params?: {}): Promise<List>;
    sapiGetLendingAutoInvestTargetAssetList (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestTargetAssetRoiList (params?: {}): Promise<List>;
    sapiGetLendingAutoInvestAllAsset (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestSourceAssetList (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestPlanList (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestPlanId (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestHistoryList (params?: {}): Promise<List>;
    sapiGetLendingAutoInvestIndexInfo (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestIndexUserSummary (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestOneOffStatus (params?: {}): Promise<Dict>;
    sapiGetLendingAutoInvestRedeemHistory (params?: {}): Promise<List>;
    sapiGetLendingAutoInvestRebalanceHistory (params?: {}): Promise<List>;
    sapiGetSimpleEarnFlexibleList (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedList (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexiblePersonalLeftQuota (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedPersonalLeftQuota (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexibleSubscriptionPreview (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedSubscriptionPreview (params?: {}): Promise<List>;
    sapiGetSimpleEarnFlexibleHistoryRateHistory (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexiblePosition (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedPosition (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnAccount (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexibleHistorySubscriptionRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedHistorySubscriptionRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexibleHistoryRedemptionRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedHistoryRedemptionRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexibleHistoryRewardsRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnLockedHistoryRewardsRecord (params?: {}): Promise<Dict>;
    sapiGetSimpleEarnFlexibleHistoryCollateralRecord (params?: {}): Promise<Dict>;
    sapiGetDciProductList (params?: {}): Promise<Dict>;
    sapiGetDciProductPositions (params?: {}): Promise<Dict>;
    sapiGetDciProductAccounts (params?: {}): Promise<Dict>;
    sapiGetAccumulatorProductList (params?: {}): Promise<Dict>;
    sapiGetAccumulatorProductPositionList (params?: {}): Promise<Dict>;
    sapiGetAccumulatorProductSumHolding (params?: {}): Promise<Dict>;
    sapiGetEquityMarketExchangeInfo (params?: {}): Promise<Dict>;
    sapiGetEquityMarketTokenizedAssets (params?: {}): Promise<Dict>;
    sapiGetEquityMarketQuote (params?: {}): Promise<Dict>;
    sapiGetEquityOrderOpenOrders (params?: {}): Promise<List>;
    sapiGetEquityOrderHistory (params?: {}): Promise<Dict>;
    sapiGetEquityOrderDetail (params?: {}): Promise<Dict>;
    sapiGetEquityTradeHistory (params?: {}): Promise<Dict>;
    sapiGetEquityTokenizedConvertStatus (params?: {}): Promise<Dict>;
    sapiGetEquityTokenizedHistory (params?: {}): Promise<Dict>;
    sapiPostAssetDust (params?: {}): Promise<Dict>;
    sapiPostAssetDustBtc (params?: {}): Promise<Dict>;
    sapiPostAssetTransfer (params?: {}): Promise<Dict>;
    sapiPostAssetGetFundingAsset (params?: {}): Promise<List>;
    sapiPostAssetConvertTransfer (params?: {}): Promise<Dict>;
    sapiPostAccountDisableFastWithdrawSwitch (params?: {}): Promise<Dict>;
    sapiPostAccountEnableFastWithdrawSwitch (params?: {}): Promise<Dict>;
    sapiPostCapitalWithdrawApply (params?: {}): Promise<Dict>;
    sapiPostCapitalContractConvertibleCoins (params?: {}): Promise<Dict>;
    sapiPostCapitalDepositCreditApply (params?: {}): Promise<Dict>;
    sapiPostMarginBorrowRepay (params?: {}): Promise<Dict>;
    sapiPostMarginTransfer (params?: {}): Promise<Dict>;
    sapiPostMarginLoan (params?: {}): Promise<Dict>;
    sapiPostMarginRepay (params?: {}): Promise<Dict>;
    sapiPostMarginOrder (params?: {}): Promise<Dict>;
    sapiPostMarginOrderOco (params?: {}): Promise<Dict>;
    sapiPostMarginDust (params?: {}): Promise<Dict>;
    sapiPostMarginExchangeSmallLiability (params?: {}): Promise<Dict>;
    sapiPostMarginIsolatedTransfer (params?: {}): Promise<Dict>;
    sapiPostMarginIsolatedAccount (params?: {}): Promise<Dict>;
    sapiPostMarginMaxLeverage (params?: {}): Promise<Dict>;
    sapiPostBnbBurn (params?: {}): Promise<Dict>;
    sapiPostSubAccountVirtualSubAccount (params?: {}): Promise<Dict>;
    sapiPostSubAccountMarginTransfer (params?: {}): Promise<Dict>;
    sapiPostSubAccountMarginEnable (params?: {}): Promise<Dict>;
    sapiPostSubAccountFuturesEnable (params?: {}): Promise<Dict>;
    sapiPostSubAccountFuturesTransfer (params?: {}): Promise<Dict>;
    sapiPostSubAccountFuturesInternalTransfer (params?: {}): Promise<Dict>;
    sapiPostSubAccountTransferSubToSub (params?: {}): Promise<Dict>;
    sapiPostSubAccountTransferSubToMaster (params?: {}): Promise<Dict>;
    sapiPostSubAccountUniversalTransfer (params?: {}): Promise<Dict>;
    sapiPostSubAccountOptionsEnable (params?: {}): Promise<Dict>;
    sapiPostManagedSubaccountDeposit (params?: {}): Promise<Dict>;
    sapiPostManagedSubaccountWithdraw (params?: {}): Promise<Dict>;
    sapiPostUserDataStream (params?: {}): Promise<Dict>;
    sapiPostUserDataStreamIsolated (params?: {}): Promise<Dict>;
    sapiPostUserListenToken (params?: {}): Promise<Dict>;
    sapiPostFuturesTransfer (params?: {}): Promise<Dict>;
    sapiPostLendingCustomizedFixedPurchase (params?: {}): Promise<Dict>;
    sapiPostLendingDailyPurchase (params?: {}): Promise<Dict>;
    sapiPostLendingDailyRedeem (params?: {}): Promise<Dict>;
    sapiPostBswapLiquidityAdd (params?: {}): Promise<Dict>;
    sapiPostBswapLiquidityRemove (params?: {}): Promise<Dict>;
    sapiPostBswapSwap (params?: {}): Promise<Dict>;
    sapiPostBswapClaimRewards (params?: {}): Promise<Dict>;
    sapiPostBlvtSubscribe (params?: {}): Promise<Dict>;
    sapiPostBlvtRedeem (params?: {}): Promise<Dict>;
    sapiPostApiReferralCustomization (params?: {}): Promise<Dict>;
    sapiPostApiReferralUserCustomization (params?: {}): Promise<Dict>;
    sapiPostApiReferralRebateHistoricalRecord (params?: {}): Promise<List>;
    sapiPostApiReferralKickbackHistoricalRecord (params?: {}): Promise<List>;
    sapiPostBrokerSubAccount (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountMargin (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountFutures (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApi (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiPermission (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiCommission (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiCommissionFutures (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiCommissionCoinFutures (params?: {}): Promise<Dict>;
    sapiPostBrokerTransfer (params?: {}): Promise<Dict>;
    sapiPostBrokerTransferFutures (params?: {}): Promise<Dict>;
    sapiPostBrokerRebateHistoricalRecord (params?: {}): Promise<List>;
    sapiPostBrokerSubAccountBnbBurnSpot (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountBnbBurnMarginInterest (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountBlvt (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiIpRestriction (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiIpRestrictionIpList (params?: {}): Promise<Dict>;
    sapiPostBrokerUniversalTransfer (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiPermissionUniversalTransfer (params?: {}): Promise<Dict>;
    sapiPostBrokerSubAccountApiPermissionVanillaOptions (params?: {}): Promise<Dict>;
    sapiPostGiftcardCreateCode (params?: {}): Promise<Dict>;
    sapiPostGiftcardRedeemCode (params?: {}): Promise<Dict>;
    sapiPostGiftcardBuyCode (params?: {}): Promise<Dict>;
    sapiPostAlgoSpotNewOrderTwap (params?: {}): Promise<Dict>;
    sapiPostAlgoFuturesNewOrderVp (params?: {}): Promise<Dict>;
    sapiPostAlgoFuturesNewOrderTwap (params?: {}): Promise<Dict>;
    sapiPostStakingPurchase (params?: {}): Promise<Dict>;
    sapiPostStakingRedeem (params?: {}): Promise<Dict>;
    sapiPostStakingSetAutoStaking (params?: {}): Promise<Dict>;
    sapiPostEthStakingEthStake (params?: {}): Promise<Dict>;
    sapiPostEthStakingEthRedeem (params?: {}): Promise<Dict>;
    sapiPostEthStakingWbethWrap (params?: {}): Promise<Dict>;
    sapiPostSolStakingSolStake (params?: {}): Promise<Dict>;
    sapiPostSolStakingSolRedeem (params?: {}): Promise<Dict>;
    sapiPostMiningHashTransferConfig (params?: {}): Promise<Dict>;
    sapiPostMiningHashTransferConfigCancel (params?: {}): Promise<Dict>;
    sapiPostPortfolioRepay (params?: {}): Promise<Dict>;
    sapiPostLoanVipRenew (params?: {}): Promise<Dict>;
    sapiPostLoanVipBorrow (params?: {}): Promise<Dict>;
    sapiPostLoanBorrow (params?: {}): Promise<Dict>;
    sapiPostLoanRepay (params?: {}): Promise<Dict>;
    sapiPostLoanAdjustLtv (params?: {}): Promise<Dict>;
    sapiPostLoanCustomizeMarginCall (params?: {}): Promise<Dict>;
    sapiPostLoanFlexibleRepay (params?: {}): Promise<Dict>;
    sapiPostLoanFlexibleAdjustLtv (params?: {}): Promise<Dict>;
    sapiPostLoanVipRepay (params?: {}): Promise<Dict>;
    sapiPostConvertGetQuote (params?: {}): Promise<Dict>;
    sapiPostConvertAcceptQuote (params?: {}): Promise<Dict>;
    sapiPostConvertLimitPlaceOrder (params?: {}): Promise<Dict>;
    sapiPostConvertLimitCancelOrder (params?: {}): Promise<Dict>;
    sapiPostPortfolioAutoCollection (params?: {}): Promise<Dict>;
    sapiPostPortfolioAssetCollection (params?: {}): Promise<Dict>;
    sapiPostPortfolioBnbTransfer (params?: {}): Promise<Dict>;
    sapiPostPortfolioRepayFuturesSwitch (params?: {}): Promise<Dict>;
    sapiPostPortfolioRepayFuturesNegativeBalance (params?: {}): Promise<Dict>;
    sapiPostPortfolioMint (params?: {}): Promise<Dict>;
    sapiPostPortfolioRedeem (params?: {}): Promise<Dict>;
    sapiPostPortfolioEarnAssetTransfer (params?: {}): Promise<Dict>;
    sapiPostPortfolioDeltaMode (params?: {}): Promise<Dict>;
    sapiPostLendingAutoInvestPlanAdd (params?: {}): Promise<Dict>;
    sapiPostLendingAutoInvestPlanEdit (params?: {}): Promise<Dict>;
    sapiPostLendingAutoInvestPlanEditStatus (params?: {}): Promise<Dict>;
    sapiPostLendingAutoInvestOneOff (params?: {}): Promise<Dict>;
    sapiPostLendingAutoInvestRedeem (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnFlexibleSubscribe (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnLockedSubscribe (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnFlexibleRedeem (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnLockedRedeem (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnFlexibleSetAutoSubscribe (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnLockedSetAutoSubscribe (params?: {}): Promise<Dict>;
    sapiPostSimpleEarnLockedSetRedeemOption (params?: {}): Promise<Dict>;
    sapiPostDciProductSubscribe (params?: {}): Promise<Dict>;
    sapiPostDciProductAutoCompoundEdit (params?: {}): Promise<Dict>;
    sapiPostAccumulatorProductSubscribe (params?: {}): Promise<Dict>;
    sapiPostEquityOrderPlace (params?: {}): Promise<Dict>;
    sapiPostEquityOrderCancel (params?: {}): Promise<Dict>;
    sapiPostEquityOrderCancelAll (params?: {}): Promise<Dict>;
    sapiPostEquityTokenizedMint (params?: {}): Promise<Dict>;
    sapiPostEquityTokenizedRedeem (params?: {}): Promise<Dict>;
    sapiPostEquityAccountDisclaimer (params?: {}): Promise<Dict>;
    sapiPostEquityListenKey (params?: {}): Promise<Dict>;
    sapiPutUserDataStream (params?: {}): Promise<Dict>;
    sapiPutUserDataStreamIsolated (params?: {}): Promise<Dict>;
    sapiDeleteMarginOpenOrders (params?: {}): Promise<List>;
    sapiDeleteMarginOrder (params?: {}): Promise<Dict>;
    sapiDeleteMarginOrderList (params?: {}): Promise<Dict>;
    sapiDeleteMarginIsolatedAccount (params?: {}): Promise<Dict>;
    sapiDeleteUserDataStream (params?: {}): Promise<Dict>;
    sapiDeleteUserDataStreamIsolated (params?: {}): Promise<Dict>;
    sapiDeleteBrokerSubAccountApi (params?: {}): Promise<Dict>;
    sapiDeleteBrokerSubAccountApiIpRestrictionIpList (params?: {}): Promise<Dict>;
    sapiDeleteAlgoSpotOrder (params?: {}): Promise<Dict>;
    sapiDeleteAlgoFuturesOrder (params?: {}): Promise<Dict>;
    sapiDeleteSubAccountSubAccountApiIpRestrictionIpList (params?: {}): Promise<Dict>;
    sapiV2GetEthStakingAccount (params?: {}): Promise<Dict>;
    sapiV2GetSubAccountFuturesAccount (params?: {}): Promise<Dict>;
    sapiV2GetSubAccountFuturesAccountSummary (params?: {}): Promise<Dict>;
    sapiV2GetSubAccountFuturesPositionRisk (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleOngoingOrders (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleBorrowHistory (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleRepayHistory (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleLtvAdjustmentHistory (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleLoanableData (params?: {}): Promise<Dict>;
    sapiV2GetLoanFlexibleCollateralData (params?: {}): Promise<Dict>;
    sapiV2GetPortfolioAccount (params?: {}): Promise<Dict>;
    sapiV2PostEthStakingEthStake (params?: {}): Promise<Dict>;
    sapiV2PostSubAccountSubAccountApiIpRestriction (params?: {}): Promise<Dict>;
    sapiV2PostLoanFlexibleBorrow (params?: {}): Promise<Dict>;
    sapiV2PostLoanFlexibleRepay (params?: {}): Promise<Dict>;
    sapiV2PostLoanFlexibleAdjustLtv (params?: {}): Promise<Dict>;
    sapiV3GetSubAccountAssets (params?: {}): Promise<Dict>;
    sapiV3PostAssetGetUserAsset (params?: {}): Promise<List>;
    sapiV4GetSubAccountAssets (params?: {}): Promise<Dict>;
    dapiPublicGetPing (params?: {}): Promise<Dict>;
    dapiPublicGetTime (params?: {}): Promise<Dict>;
    dapiPublicGetExchangeInfo (params?: {}): Promise<Dict>;
    dapiPublicGetDepth (params?: {}): Promise<Dict>;
    dapiPublicGetTrades (params?: {}): Promise<List>;
    dapiPublicGetHistoricalTrades (params?: {}): Promise<List>;
    dapiPublicGetAggTrades (params?: {}): Promise<List>;
    dapiPublicGetPremiumIndex (params?: {}): Promise<List>;
    dapiPublicGetFundingRate (params?: {}): Promise<List>;
    dapiPublicGetKlines (params?: {}): Promise<List>;
    dapiPublicGetContinuousKlines (params?: {}): Promise<List>;
    dapiPublicGetIndexPriceKlines (params?: {}): Promise<List>;
    dapiPublicGetMarkPriceKlines (params?: {}): Promise<List>;
    dapiPublicGetPremiumIndexKlines (params?: {}): Promise<List>;
    dapiPublicGetTicker24hr (params?: {}): Promise<Dict | List>;
    dapiPublicGetTickerPrice (params?: {}): Promise<List>;
    dapiPublicGetTickerBookTicker (params?: {}): Promise<List>;
    dapiPublicGetConstituents (params?: {}): Promise<Dict>;
    dapiPublicGetOpenInterest (params?: {}): Promise<Dict>;
    dapiPublicGetFundingInfo (params?: {}): Promise<List>;
    dapiDataGetDeliveryPrice (params?: {}): Promise<List>;
    dapiDataGetOpenInterestHist (params?: {}): Promise<List>;
    dapiDataGetTopLongShortAccountRatio (params?: {}): Promise<List>;
    dapiDataGetTopLongShortPositionRatio (params?: {}): Promise<List>;
    dapiDataGetGlobalLongShortAccountRatio (params?: {}): Promise<List>;
    dapiDataGetTakerBuySellVol (params?: {}): Promise<List>;
    dapiDataGetBasis (params?: {}): Promise<List>;
    dapiPrivateGetPositionSideDual (params?: {}): Promise<Dict>;
    dapiPrivateGetOrderAmendment (params?: {}): Promise<List>;
    dapiPrivateGetOrder (params?: {}): Promise<Dict>;
    dapiPrivateGetOpenOrder (params?: {}): Promise<Dict>;
    dapiPrivateGetOpenOrders (params?: {}): Promise<List>;
    dapiPrivateGetOpenAlgoOrders (params?: {}): Promise<List>;
    dapiPrivateGetAllOrders (params?: {}): Promise<List>;
    dapiPrivateGetBalance (params?: {}): Promise<List>;
    dapiPrivateGetAccount (params?: {}): Promise<Dict>;
    dapiPrivateGetPositionMarginHistory (params?: {}): Promise<List>;
    dapiPrivateGetPositionRisk (params?: {}): Promise<List>;
    dapiPrivateGetUserTrades (params?: {}): Promise<List>;
    dapiPrivateGetIncome (params?: {}): Promise<List>;
    dapiPrivateGetLeverageBracket (params?: {}): Promise<List>;
    dapiPrivateGetForceOrders (params?: {}): Promise<Dict>;
    dapiPrivateGetAdlQuantile (params?: {}): Promise<List>;
    dapiPrivateGetCommissionRate (params?: {}): Promise<Dict>;
    dapiPrivateGetIncomeAsyn (params?: {}): Promise<Dict>;
    dapiPrivateGetIncomeAsynId (params?: {}): Promise<Dict>;
    dapiPrivateGetTradeAsyn (params?: {}): Promise<Dict>;
    dapiPrivateGetTradeAsynId (params?: {}): Promise<Dict>;
    dapiPrivateGetOrderAsyn (params?: {}): Promise<Dict>;
    dapiPrivateGetOrderAsynId (params?: {}): Promise<Dict>;
    dapiPrivateGetPmExchangeInfo (params?: {}): Promise<Dict>;
    dapiPrivateGetPmAccountInfo (params?: {}): Promise<Dict>;
    dapiPrivatePostPositionSideDual (params?: {}): Promise<Dict>;
    dapiPrivatePostOrder (params?: {}): Promise<Dict>;
    dapiPrivatePostAlgoOrder (params?: {}): Promise<Dict>;
    dapiPrivatePostBatchOrders (params?: {}): Promise<List>;
    dapiPrivatePostCountdownCancelAll (params?: {}): Promise<Dict>;
    dapiPrivatePostLeverage (params?: {}): Promise<Dict>;
    dapiPrivatePostMarginType (params?: {}): Promise<Dict>;
    dapiPrivatePostPositionMargin (params?: {}): Promise<Dict>;
    dapiPrivatePostListenKey (params?: {}): Promise<Dict>;
    dapiPrivatePutListenKey (params?: {}): Promise<Dict>;
    dapiPrivatePutOrder (params?: {}): Promise<Dict>;
    dapiPrivatePutBatchOrders (params?: {}): Promise<List>;
    dapiPrivateDeleteOrder (params?: {}): Promise<Dict>;
    dapiPrivateDeleteAlgoOrder (params?: {}): Promise<Dict>;
    dapiPrivateDeleteAllOpenOrders (params?: {}): Promise<List>;
    dapiPrivateDeleteBatchOrders (params?: {}): Promise<List>;
    dapiPrivateDeleteListenKey (params?: {}): Promise<Dict>;
    dapiPrivateV2GetLeverageBracket (params?: {}): Promise<List>;
    fapiPublicGetPing (params?: {}): Promise<Dict>;
    fapiPublicGetTime (params?: {}): Promise<Dict>;
    fapiPublicGetExchangeInfo (params?: {}): Promise<Dict>;
    fapiPublicGetDepth (params?: {}): Promise<Dict>;
    fapiPublicGetRpiDepth (params?: {}): Promise<Dict>;
    fapiPublicGetTrades (params?: {}): Promise<List>;
    fapiPublicGetHistoricalTrades (params?: {}): Promise<List>;
    fapiPublicGetAggTrades (params?: {}): Promise<List>;
    fapiPublicGetKlines (params?: {}): Promise<List>;
    fapiPublicGetContinuousKlines (params?: {}): Promise<List>;
    fapiPublicGetMarkPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetIndexPriceKlines (params?: {}): Promise<List>;
    fapiPublicGetPremiumIndexKlines (params?: {}): Promise<List>;
    fapiPublicGetFundingRate (params?: {}): Promise<List>;
    fapiPublicGetFundingInfo (params?: {}): Promise<List>;
    fapiPublicGetPremiumIndex (params?: {}): Promise<List>;
    fapiPublicGetTicker24hr (params?: {}): Promise<Dict | List>;
    fapiPublicGetTickerPrice (params?: {}): Promise<Dict | List>;
    fapiPublicGetTickerBookTicker (params?: {}): Promise<Dict | List>;
    fapiPublicGetOpenInterest (params?: {}): Promise<Dict>;
    fapiPublicGetIndexInfo (params?: {}): Promise<List>;
    fapiPublicGetAssetIndex (params?: {}): Promise<Dict>;
    fapiPublicGetConstituents (params?: {}): Promise<Dict>;
    fapiPublicGetApiTradingStatus (params?: {}): Promise<Dict>;
    fapiPublicGetLvtKlines (params?: {}): Promise<List>;
    fapiPublicGetConvertExchangeInfo (params?: {}): Promise<List>;
    fapiPublicGetInsuranceBalance (params?: {}): Promise<List>;
    fapiPublicGetSymbolAdlRisk (params?: {}): Promise<Dict>;
    fapiPublicGetTradingSchedule (params?: {}): Promise<Dict>;
    fapiDataGetDeliveryPrice (params?: {}): Promise<List>;
    fapiDataGetOpenInterestHist (params?: {}): Promise<List>;
    fapiDataGetTopLongShortAccountRatio (params?: {}): Promise<List>;
    fapiDataGetTopLongShortPositionRatio (params?: {}): Promise<List>;
    fapiDataGetGlobalLongShortAccountRatio (params?: {}): Promise<List>;
    fapiDataGetTakerlongshortRatio (params?: {}): Promise<List>;
    fapiDataGetBasis (params?: {}): Promise<List>;
    fapiPrivateGetForceOrders (params?: {}): Promise<Dict>;
    fapiPrivateGetAllOrders (params?: {}): Promise<List>;
    fapiPrivateGetOpenOrder (params?: {}): Promise<Dict>;
    fapiPrivateGetOpenOrders (params?: {}): Promise<List>;
    fapiPrivateGetOrder (params?: {}): Promise<Dict>;
    fapiPrivateGetAccount (params?: {}): Promise<Dict>;
    fapiPrivateGetBalance (params?: {}): Promise<List>;
    fapiPrivateGetLeverageBracket (params?: {}): Promise<List>;
    fapiPrivateGetPositionMarginHistory (params?: {}): Promise<List>;
    fapiPrivateGetPositionRisk (params?: {}): Promise<List>;
    fapiPrivateGetPositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivateGetUserTrades (params?: {}): Promise<List>;
    fapiPrivateGetIncome (params?: {}): Promise<List>;
    fapiPrivateGetCommissionRate (params?: {}): Promise<Dict>;
    fapiPrivateGetRateLimitOrder (params?: {}): Promise<List>;
    fapiPrivateGetApiTradingStatus (params?: {}): Promise<Dict>;
    fapiPrivateGetMultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivateGetApiReferralIfNewUser (params?: {}): Promise<Dict>;
    fapiPrivateGetApiReferralCustomization (params?: {}): Promise<List>;
    fapiPrivateGetApiReferralUserCustomization (params?: {}): Promise<Dict>;
    fapiPrivateGetApiReferralTraderNum (params?: {}): Promise<List>;
    fapiPrivateGetApiReferralOverview (params?: {}): Promise<Dict>;
    fapiPrivateGetApiReferralTradeVol (params?: {}): Promise<List>;
    fapiPrivateGetApiReferralRebateVol (params?: {}): Promise<List>;
    fapiPrivateGetApiReferralTraderSummary (params?: {}): Promise<List>;
    fapiPrivateGetAdlQuantile (params?: {}): Promise<List>;
    fapiPrivateGetPmAccountInfo (params?: {}): Promise<Dict>;
    fapiPrivateGetOrderAmendment (params?: {}): Promise<List>;
    fapiPrivateGetIncomeAsyn (params?: {}): Promise<Dict>;
    fapiPrivateGetIncomeAsynId (params?: {}): Promise<Dict>;
    fapiPrivateGetOrderAsyn (params?: {}): Promise<Dict>;
    fapiPrivateGetOrderAsynId (params?: {}): Promise<Dict>;
    fapiPrivateGetTradeAsyn (params?: {}): Promise<Dict>;
    fapiPrivateGetTradeAsynId (params?: {}): Promise<Dict>;
    fapiPrivateGetFeeBurn (params?: {}): Promise<Dict>;
    fapiPrivateGetSymbolConfig (params?: {}): Promise<List>;
    fapiPrivateGetAccountConfig (params?: {}): Promise<Dict>;
    fapiPrivateGetConvertOrderStatus (params?: {}): Promise<Dict>;
    fapiPrivateGetAlgoOrder (params?: {}): Promise<Dict>;
    fapiPrivateGetOpenAlgoOrders (params?: {}): Promise<List>;
    fapiPrivateGetAllAlgoOrders (params?: {}): Promise<List>;
    fapiPrivateGetStockContract (params?: {}): Promise<Dict>;
    fapiPrivatePostBatchOrders (params?: {}): Promise<List>;
    fapiPrivatePostPositionSideDual (params?: {}): Promise<Dict>;
    fapiPrivatePostPositionMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostMarginType (params?: {}): Promise<Dict>;
    fapiPrivatePostOrder (params?: {}): Promise<Dict>;
    fapiPrivatePostOrderTest (params?: {}): Promise<Dict>;
    fapiPrivatePostLeverage (params?: {}): Promise<Dict>;
    fapiPrivatePostListenKey (params?: {}): Promise<Dict>;
    fapiPrivatePostCountdownCancelAll (params?: {}): Promise<Dict>;
    fapiPrivatePostMultiAssetsMargin (params?: {}): Promise<Dict>;
    fapiPrivatePostApiReferralCustomization (params?: {}): Promise<Dict>;
    fapiPrivatePostApiReferralUserCustomization (params?: {}): Promise<Dict>;
    fapiPrivatePostFeeBurn (params?: {}): Promise<Dict>;
    fapiPrivatePostConvertGetQuote (params?: {}): Promise<Dict>;
    fapiPrivatePostConvertAcceptQuote (params?: {}): Promise<Dict>;
    fapiPrivatePostAlgoOrder (params?: {}): Promise<Dict>;
    fapiPrivatePutListenKey (params?: {}): Promise<Dict>;
    fapiPrivatePutOrder (params?: {}): Promise<Dict>;
    fapiPrivatePutBatchOrders (params?: {}): Promise<List>;
    fapiPrivateDeleteBatchOrders (params?: {}): Promise<List>;
    fapiPrivateDeleteOrder (params?: {}): Promise<Dict>;
    fapiPrivateDeleteAllOpenOrders (params?: {}): Promise<List>;
    fapiPrivateDeleteListenKey (params?: {}): Promise<Dict>;
    fapiPrivateDeleteAlgoOrder (params?: {}): Promise<Dict>;
    fapiPrivateDeleteAlgoOpenOrders (params?: {}): Promise<Dict>;
    fapiPublicV2GetTickerPrice (params?: {}): Promise<Dict | List>;
    fapiPrivateV2GetAccount (params?: {}): Promise<Dict>;
    fapiPrivateV2GetBalance (params?: {}): Promise<List>;
    fapiPrivateV2GetPositionRisk (params?: {}): Promise<List>;
    fapiPrivateV3GetAccount (params?: {}): Promise<Dict>;
    fapiPrivateV3GetBalance (params?: {}): Promise<List>;
    fapiPrivateV3GetPositionRisk (params?: {}): Promise<List>;
    eapiPublicGetPing (params?: {}): Promise<Dict>;
    eapiPublicGetTime (params?: {}): Promise<Dict>;
    eapiPublicGetExchangeInfo (params?: {}): Promise<Dict>;
    eapiPublicGetIndex (params?: {}): Promise<Dict>;
    eapiPublicGetTicker (params?: {}): Promise<List>;
    eapiPublicGetMark (params?: {}): Promise<List>;
    eapiPublicGetDepth (params?: {}): Promise<Dict>;
    eapiPublicGetKlines (params?: {}): Promise<List>;
    eapiPublicGetTrades (params?: {}): Promise<List>;
    eapiPublicGetHistoricalTrades (params?: {}): Promise<List>;
    eapiPublicGetExerciseHistory (params?: {}): Promise<List>;
    eapiPublicGetOpenInterest (params?: {}): Promise<Dict>;
    eapiPrivateGetAccount (params?: {}): Promise<Dict>;
    eapiPrivateGetPosition (params?: {}): Promise<List>;
    eapiPrivateGetOpenOrders (params?: {}): Promise<List>;
    eapiPrivateGetHistoryOrders (params?: {}): Promise<List>;
    eapiPrivateGetUserTrades (params?: {}): Promise<List>;
    eapiPrivateGetExerciseRecord (params?: {}): Promise<List>;
    eapiPrivateGetBill (params?: {}): Promise<List>;
    eapiPrivateGetIncomeAsyn (params?: {}): Promise<Dict>;
    eapiPrivateGetIncomeAsynId (params?: {}): Promise<Dict>;
    eapiPrivateGetMarginAccount (params?: {}): Promise<Dict>;
    eapiPrivateGetMmp (params?: {}): Promise<Dict>;
    eapiPrivateGetCountdownCancelAll (params?: {}): Promise<Dict>;
    eapiPrivateGetOrder (params?: {}): Promise<Dict>;
    eapiPrivateGetBlockOrderOrders (params?: {}): Promise<List>;
    eapiPrivateGetBlockOrderExecute (params?: {}): Promise<Dict>;
    eapiPrivateGetBlockUserTrades (params?: {}): Promise<List>;
    eapiPrivateGetBlockTrades (params?: {}): Promise<List>;
    eapiPrivateGetComission (params?: {}): Promise<Dict>;
    eapiPrivatePostOrder (params?: {}): Promise<Dict>;
    eapiPrivatePostBatchOrders (params?: {}): Promise<List>;
    eapiPrivatePostListenKey (params?: {}): Promise<Dict>;
    eapiPrivatePostMmpSet (params?: {}): Promise<Dict>;
    eapiPrivatePostMmpReset (params?: {}): Promise<Dict>;
    eapiPrivatePostCountdownCancelAll (params?: {}): Promise<Dict>;
    eapiPrivatePostCountdownCancelAllHeartBeat (params?: {}): Promise<Dict>;
    eapiPrivatePostBlockOrderCreate (params?: {}): Promise<Dict>;
    eapiPrivatePostBlockOrderExecute (params?: {}): Promise<Dict>;
    eapiPrivatePutListenKey (params?: {}): Promise<Dict>;
    eapiPrivatePutBlockOrderCreate (params?: {}): Promise<Dict>;
    eapiPrivateDeleteOrder (params?: {}): Promise<Dict>;
    eapiPrivateDeleteBatchOrders (params?: {}): Promise<List>;
    eapiPrivateDeleteAllOpenOrders (params?: {}): Promise<List>;
    eapiPrivateDeleteAllOpenOrdersByUnderlying (params?: {}): Promise<Dict>;
    eapiPrivateDeleteListenKey (params?: {}): Promise<Dict>;
    eapiPrivateDeleteBlockOrderCreate (params?: {}): Promise<Dict>;
    publicGetPing (params?: {}): Promise<Dict>;
    publicGetTime (params?: {}): Promise<Dict>;
    publicGetDepth (params?: {}): Promise<Dict>;
    publicGetTrades (params?: {}): Promise<List>;
    publicGetAggTrades (params?: {}): Promise<List>;
    publicGetHistoricalTrades (params?: {}): Promise<List>;
    publicGetKlines (params?: {}): Promise<List>;
    publicGetUiKlines (params?: {}): Promise<List>;
    publicGetTicker24hr (params?: {}): Promise<Dict | List>;
    publicGetTicker (params?: {}): Promise<List>;
    publicGetTickerTradingDay (params?: {}): Promise<Dict>;
    publicGetTickerPrice (params?: {}): Promise<Dict | List>;
    publicGetTickerBookTicker (params?: {}): Promise<List>;
    publicGetExchangeInfo (params?: {}): Promise<Dict>;
    publicGetAvgPrice (params?: {}): Promise<Dict>;
    publicPutUserDataStream (params?: {}): Promise<Dict>;
    publicPostUserDataStream (params?: {}): Promise<Dict>;
    publicDeleteUserDataStream (params?: {}): Promise<Dict>;
    privateGetAllOrderList (params?: {}): Promise<List>;
    privateGetOpenOrderList (params?: {}): Promise<List>;
    privateGetOrderList (params?: {}): Promise<Dict>;
    privateGetOrder (params?: {}): Promise<Dict>;
    privateGetOpenOrders (params?: {}): Promise<List>;
    privateGetAllOrders (params?: {}): Promise<List>;
    privateGetAccount (params?: {}): Promise<Dict>;
    privateGetMyTrades (params?: {}): Promise<List>;
    privateGetRateLimitOrder (params?: {}): Promise<List>;
    privateGetMyPreventedMatches (params?: {}): Promise<List>;
    privateGetMyAllocations (params?: {}): Promise<List>;
    privateGetAccountCommission (params?: {}): Promise<Dict>;
    privatePostOrderOco (params?: {}): Promise<Dict>;
    privatePostOrderListOco (params?: {}): Promise<Dict>;
    privatePostOrderListOto (params?: {}): Promise<Dict>;
    privatePostOrderListOtoco (params?: {}): Promise<Dict>;
    privatePostOrderListOpo (params?: {}): Promise<Dict>;
    privatePostOrderListOpoco (params?: {}): Promise<Dict>;
    privatePostSorOrder (params?: {}): Promise<Dict>;
    privatePostSorOrderTest (params?: {}): Promise<Dict>;
    privatePostOrder (params?: {}): Promise<Dict>;
    privatePostOrderCancelReplace (params?: {}): Promise<Dict>;
    privatePostOrderTest (params?: {}): Promise<Dict>;
    privateDeleteOpenOrders (params?: {}): Promise<List>;
    privateDeleteOrderList (params?: {}): Promise<Dict>;
    privateDeleteOrder (params?: {}): Promise<Dict>;
    papiGetPing (params?: {}): Promise<Dict>;
    papiGetUmOrder (params?: {}): Promise<Dict>;
    papiGetUmOpenOrder (params?: {}): Promise<Dict>;
    papiGetUmOpenOrders (params?: {}): Promise<List>;
    papiGetUmAllOrders (params?: {}): Promise<List>;
    papiGetCmOrder (params?: {}): Promise<Dict>;
    papiGetCmOpenOrder (params?: {}): Promise<Dict>;
    papiGetCmOpenOrders (params?: {}): Promise<List>;
    papiGetCmAllOrders (params?: {}): Promise<List>;
    papiGetUmConditionalOpenOrder (params?: {}): Promise<Dict>;
    papiGetUmConditionalOpenOrders (params?: {}): Promise<List>;
    papiGetUmConditionalOrderHistory (params?: {}): Promise<Dict>;
    papiGetUmConditionalAllOrders (params?: {}): Promise<List>;
    papiGetCmConditionalOpenOrder (params?: {}): Promise<Dict>;
    papiGetCmConditionalOpenOrders (params?: {}): Promise<List>;
    papiGetCmConditionalOrderHistory (params?: {}): Promise<Dict>;
    papiGetCmConditionalAllOrders (params?: {}): Promise<List>;
    papiGetMarginOrder (params?: {}): Promise<Dict>;
    papiGetMarginOpenOrders (params?: {}): Promise<List>;
    papiGetMarginAllOrders (params?: {}): Promise<List>;
    papiGetMarginOrderList (params?: {}): Promise<Dict>;
    papiGetMarginAllOrderList (params?: {}): Promise<List>;
    papiGetMarginOpenOrderList (params?: {}): Promise<List>;
    papiGetMarginMyTrades (params?: {}): Promise<List>;
    papiGetBalance (params?: {}): Promise<List>;
    papiGetAccount (params?: {}): Promise<Dict>;
    papiGetMarginMaxBorrowable (params?: {}): Promise<Dict>;
    papiGetMarginMaxWithdraw (params?: {}): Promise<Dict>;
    papiGetUmPositionRisk (params?: {}): Promise<List>;
    papiGetCmPositionRisk (params?: {}): Promise<List>;
    papiGetUmPositionSideDual (params?: {}): Promise<Dict>;
    papiGetCmPositionSideDual (params?: {}): Promise<Dict>;
    papiGetUmUserTrades (params?: {}): Promise<List>;
    papiGetCmUserTrades (params?: {}): Promise<List>;
    papiGetUmLeverageBracket (params?: {}): Promise<List>;
    papiGetCmLeverageBracket (params?: {}): Promise<List>;
    papiGetMarginForceOrders (params?: {}): Promise<Dict>;
    papiGetUmForceOrders (params?: {}): Promise<Dict>;
    papiGetCmForceOrders (params?: {}): Promise<Dict>;
    papiGetUmApiTradingStatus (params?: {}): Promise<Dict>;
    papiGetUmCommissionRate (params?: {}): Promise<Dict>;
    papiGetCmCommissionRate (params?: {}): Promise<Dict>;
    papiGetMarginMarginLoan (params?: {}): Promise<Dict>;
    papiGetMarginRepayLoan (params?: {}): Promise<Dict>;
    papiGetMarginMarginInterestHistory (params?: {}): Promise<Dict>;
    papiGetPortfolioInterestHistory (params?: {}): Promise<List>;
    papiGetUmIncome (params?: {}): Promise<List>;
    papiGetCmIncome (params?: {}): Promise<List>;
    papiGetUmAccount (params?: {}): Promise<Dict>;
    papiGetCmAccount (params?: {}): Promise<Dict>;
    papiGetRepayFuturesSwitch (params?: {}): Promise<Dict>;
    papiGetUmAdlQuantile (params?: {}): Promise<List>;
    papiGetCmAdlQuantile (params?: {}): Promise<List>;
    papiGetUmTradeAsyn (params?: {}): Promise<Dict>;
    papiGetUmTradeAsynId (params?: {}): Promise<Dict>;
    papiGetUmOrderAsyn (params?: {}): Promise<Dict>;
    papiGetUmOrderAsynId (params?: {}): Promise<Dict>;
    papiGetUmIncomeAsyn (params?: {}): Promise<Dict>;
    papiGetUmIncomeAsynId (params?: {}): Promise<Dict>;
    papiGetUmOrderAmendment (params?: {}): Promise<List>;
    papiGetCmOrderAmendment (params?: {}): Promise<List>;
    papiGetUmFeeBurn (params?: {}): Promise<Dict>;
    papiGetUmAccountConfig (params?: {}): Promise<Dict>;
    papiGetUmSymbolConfig (params?: {}): Promise<List>;
    papiGetCmAccountConfig (params?: {}): Promise<Dict>;
    papiGetCmSymbolConfig (params?: {}): Promise<Dict>;
    papiGetRateLimitOrder (params?: {}): Promise<List>;
    papiPostUmOrder (params?: {}): Promise<Dict>;
    papiPostUmConditionalOrder (params?: {}): Promise<Dict>;
    papiPostCmOrder (params?: {}): Promise<Dict>;
    papiPostCmConditionalOrder (params?: {}): Promise<Dict>;
    papiPostMarginOrder (params?: {}): Promise<Dict>;
    papiPostMarginLoan (params?: {}): Promise<Dict>;
    papiPostRepayLoan (params?: {}): Promise<Dict>;
    papiPostMarginOrderOco (params?: {}): Promise<Dict>;
    papiPostUmLeverage (params?: {}): Promise<Dict>;
    papiPostCmLeverage (params?: {}): Promise<Dict>;
    papiPostUmPositionSideDual (params?: {}): Promise<Dict>;
    papiPostCmPositionSideDual (params?: {}): Promise<Dict>;
    papiPostAutoCollection (params?: {}): Promise<Dict>;
    papiPostBnbTransfer (params?: {}): Promise<Dict>;
    papiPostRepayFuturesSwitch (params?: {}): Promise<Dict>;
    papiPostRepayFuturesNegativeBalance (params?: {}): Promise<Dict>;
    papiPostListenKey (params?: {}): Promise<Dict>;
    papiPostAssetCollection (params?: {}): Promise<Dict>;
    papiPostMarginRepayDebt (params?: {}): Promise<Dict>;
    papiPostUmFeeBurn (params?: {}): Promise<Dict>;
    papiPostUmStockContract (params?: {}): Promise<Dict>;
    papiPutListenKey (params?: {}): Promise<Dict>;
    papiPutUmOrder (params?: {}): Promise<Dict>;
    papiPutCmOrder (params?: {}): Promise<Dict>;
    papiDeleteUmOrder (params?: {}): Promise<Dict>;
    papiDeleteUmConditionalOrder (params?: {}): Promise<Dict>;
    papiDeleteUmAllOpenOrders (params?: {}): Promise<List>;
    papiDeleteUmConditionalAllOpenOrders (params?: {}): Promise<List>;
    papiDeleteCmOrder (params?: {}): Promise<Dict>;
    papiDeleteCmConditionalOrder (params?: {}): Promise<Dict>;
    papiDeleteCmAllOpenOrders (params?: {}): Promise<List>;
    papiDeleteCmConditionalAllOpenOrders (params?: {}): Promise<List>;
    papiDeleteMarginOrder (params?: {}): Promise<Dict>;
    papiDeleteMarginAllOpenOrders (params?: {}): Promise<List>;
    papiDeleteMarginOrderList (params?: {}): Promise<Dict>;
    papiDeleteListenKey (params?: {}): Promise<Dict>;
    papiV2GetUmAccount (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
